
import { Component, Vue } from "vue-property-decorator";
import FormLogin from "../components/authentification/login/FormLogin.vue";
import { Logger } from "@/utils/Logger";
import Etablissement from "@/core/Etablissement";

@Component({
  components: { FormLogin }
})
export default class App extends Vue {
  public metaInfo(): any {
    return {
      meta: [
        {
          name: "description",
          content: "Page de connexion de l'application des Licences Nationales"
        }
      ],
      title: "Connexion - Licences Nationales"
    };
  }

  forgotPasswordVisible: boolean = false;
  creerCompte(): void {
    this.$store
      .dispatch("setCurrentEtablissement", new Etablissement())
      .then(() => {
        this.$router.push({ name: "CreationEtablissement" });
      })
      .catch(err => {
        Logger.error(err);
      });
  }

  afficherMotDePasseOublie(): void {
    this.$store.dispatch("closeDisplayedMessage");
    this.$router.push({ name: "ForgotPassword" });
  }
}
